export function panelId(label: string): string {
  return `accordion-panel-${label.replace(/\s+/g, '-').toLowerCase()}`;
}
